import { render } from "./messages.html?vue&type=template&id=6228397a&ts=true"
import script from "./messages.ts?vue&type=script&lang=ts"
export * from "./messages.ts?vue&type=script&lang=ts"

import "./messages.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\Desarrollo\\Proyectos\\Codigo\\Helpharma\\Vigiflow\\automation-logs-adminlte-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__